import { vaultFilesApi } from "@api";

import { useDownloadPdf } from "../../../Invoices/utils";
import { useWSMutation } from "../../../query/helpers";
import { WSServiceError } from "../../../utils/serviceHelper";

/**
 * Downloads a paystub's PDF. The pay statement only carries a `fileId`
 * pointing at the vault; the SDK types the content read as `void`, so the
 * blob is read off the raw response (`getVaultFileContentRaw().raw.blob()`),
 * the same escape hatch used for other binary downloads (e.g. W-9 forms).
 */
export const useMutationDownloadPaystubPdf = () => {
  const downloadPdf = useDownloadPdf();

  return useWSMutation<
    void,
    WSServiceError,
    { fileId: string; filename: string }
  >(async ({ fileId, filename }) => {
    const response = await vaultFilesApi.getVaultFileContentRaw({
      fileId
    });
    const blob = await response.raw.blob();
    const url = window.URL.createObjectURL(blob);
    downloadPdf(url, `${filename}.pdf`);
  });
};
